import { useState } from 'react';
import { BookOpen, CaretDown, CaretUp, ArrowSquareOut } from '@phosphor-icons/react';
import type { SourceCitation } from '../../stores/chatSession';

interface Props {
  sources: SourceCitation[];
}

const COLLECTION_LABELS: Record<SourceCitation['collection'], string> = {
  sourceDocuments: 'PubMed',
  knowledgeBase: 'Clinical guidelines',
  topics: 'ResearchHer Library',
};

export default function SourcesFooter({ sources }: Props) {
  const [open, setOpen] = useState(false);

  if (sources.length === 0) return null;

  const collectionsUsed = Array.from(new Set(sources.map(s => COLLECTION_LABELS[s.collection]))).join(' + ');

  return (
    <div className="mt-2.5">
      <button
        onClick={() => setOpen(o => !o)}
        className="inline-flex items-center gap-1.5 text-[11px] text-gray-500 dark:text-gray-400 hover:text-pink-600 dark:hover:text-pink-400 transition-colors"
      >
        <BookOpen size={12} weight="duotone" />
        <span>{sources.length} {sources.length === 1 ? 'source' : 'sources'} · {collectionsUsed}</span>
        {open ? <CaretUp size={10} /> : <CaretDown size={10} />}
      </button>
      {open && (
        <ul className="mt-1.5 space-y-1 pl-4">
          {sources.map((s, i) => (
            <li key={i} className="text-[11px] text-gray-600 dark:text-gray-300 leading-snug">
              {s.sourceUrl ? (
                <a
                  href={s.sourceUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-baseline gap-1 hover:text-pink-600 dark:hover:text-pink-400 transition-colors"
                >
                  <span>{s.title}</span>
                  <ArrowSquareOut size={10} className="flex-shrink-0 self-center" />
                </a>
              ) : (
                <span>{s.title}</span>
              )}
              <span className="text-gray-400 dark:text-gray-500"> · {s.source}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
